import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const StarredContentMenuLoader: LoadableType<{}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-StarredContentMenu" */
				'../../ContentMenu/StarredContentMenu.tsx'
			)
		).StarredContentMenu,
});
